import React, { useMemo } from "react";
import { Divider, Logo, NavigationWrapper } from "./styles";
import NeoLogo from "assets/svgs/neoInsuranceLogoWhite_risk.svg";
import Menu from "./Menu";
import { Link, useLocation } from "react-router-dom";
import useUser from "hooks/useUser";
import { planSetupInProgress, planSetupPendingInProgress } from "utlis/utils";

function Navigation() {
  const { getRole } = useUser();
  const role = getRole();

  const displayMenuItems = () => {
    if (planSetupInProgress() || planSetupPendingInProgress()) {
      return null;
    }
    return (
      <>
        <article>
          <Menu />
        </article>
      </>
    );
  };

  return (
    <NavigationWrapper>
      <header>
        <Link
          to={role === "admin" ? "/" : "#"}
          style={{
            cursor: role === "admin" ? "pointer" : "default",
          }}
        >
          <Logo role={role} src={NeoLogo} />
        </Link>
        <Divider />
      </header>
      {displayMenuItems()}
    </NavigationWrapper>
  );
}

export default Navigation;
